import React from "react";
import { useTranslation } from "react-i18next";
import { QUICK_STARTS } from "./SearchHeader.constants.tsx";

export const QuickStartsGrid: React.FC = () => {
  const { t, i18n } = useTranslation();
  const lang = (i18n.language?.startsWith("en") ? "en" : i18n.language?.startsWith("ru") ? "ru" : "et") as "et" | "en" | "ru";
  const indexPaths = { et: "static/artiklid", en: "static/articles", ru: "static/statyi" };

  return (
    <>
      <div className="mt-12 grid grid-cols-1 sm:grid-cols-2 gap-4 animate-message">
        {QUICK_STARTS.map((item, idx) => {
          const title = t(`landing.quick_starts.${item.id}.title`);
          const q = t(`landing.quick_starts.${item.id}.query`);
          const basePaths = { et: "static/artikkel", en: "static/articles", ru: "static/statyi" };
          const href = `/${basePaths[lang]}/${item.slugs[lang as keyof typeof item.slugs]}`;

          return (
            <a
              key={idx}
              href={href}
              className={`flex items-center gap-4 p-4 rounded-2xl border transition-all text-left hover:scale-[1.02] active:scale-[0.98] ${item.color} group no-underline`}
            >
              <div className="shrink-0 group-hover:scale-110 transition-transform">
                {item.icon}
              </div>
              <div className="flex flex-col">
                <span className="font-bold text-slate-900 dark:text-white text-sm sm:text-base">{title}</span>
                <span className="text-xs opacity-80 line-clamp-1">{q}</span>
              </div>
            </a>
          );
        })}
      </div>

      <div className="mt-8 flex justify-center animate-message">
        <a
          href={`/${indexPaths[lang]}`}
          className="group inline-flex items-center gap-2 px-6 py-2.5 rounded-full border border-slate-200 dark:border-slate-800 bg-white/50 dark:bg-slate-900/50 backdrop-blur-md text-sm font-medium text-slate-600 dark:text-slate-400 hover:text-blue-600 dark:hover:text-blue-400 hover:border-blue-200 dark:hover:border-blue-900/50 shadow-sm hover:shadow transition-all duration-300 no-underline"
        >
          <span>{t("landing.see_more")}</span>
          <svg
            xmlns="http://www.w3.org/2000/svg"
            width="16"
            height="16"
            viewBox="0 0 24 24"
            fill="none"
            stroke="currentColor"
            strokeWidth="2.5"
            strokeLinecap="round"
            strokeLinejoin="round"
            className="transition-transform duration-300 group-hover:translate-x-1"
          >
            <line x1="5" y1="12" x2="19" y2="12"></line>
            <polyline points="12 5 19 12 12 19"></polyline>
          </svg>
        </a>
      </div>
    </>
  );
};
